import { useEffect } from "react";
import "./BinaryTrail.css";

const COLORS = ["#ecb02b", "#ff7a3d", "#ff3d68", "#ecb02b", "#fff"];
const CHARS  = ["0", "1"];

let lastX = -999;
let lastY = -999;

function spawnTrail(x, y) {
  const el = document.createElement("span");
  el.className = "bin-trail";
  el.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];
  el.style.left = (x + (Math.random() - 0.5) * 20) + "px";
  el.style.top  = (y + (Math.random() - 0.5) * 20) + "px";
  el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];
  el.style.fontSize = (Math.random() * 8 + 11) + "px";
  el.style.animationDuration = (Math.random() * 0.5 + 0.6) + "s";
  document.body.appendChild(el);
  el.addEventListener("animationend", () => el.remove(), { once: true });
}

function spawnBurst(x, y) {
  const total = 10;
  for (let i = 0; i < total; i++) {
    const angle = (i / total) * Math.PI * 2 + Math.random() * 0.6;
    const radius = 40 + Math.random() * 60;
    const el = document.createElement("span");
    el.className = "bin-trail bin-trail--burst";
    el.textContent = CHARS[Math.floor(Math.random() * CHARS.length)];
    el.style.left = (x + Math.cos(angle) * radius) + "px";
    el.style.top  = (y + Math.sin(angle) * radius) + "px";
    el.style.color = COLORS[Math.floor(Math.random() * COLORS.length)];
    el.style.fontSize = (Math.random() * 8 + 12) + "px";
    el.style.animationDuration = (Math.random() * 0.4 + 0.7) + "s";
    el.style.setProperty("--dx", Math.cos(angle) * (20 + Math.random() * 30) + "px");
    el.style.setProperty("--dy", Math.sin(angle) * (20 + Math.random() * 30) + "px");
    document.body.appendChild(el);
    el.addEventListener("animationend", () => el.remove(), { once: true });
  }
}

export default function BinaryTrail() {
  useEffect(() => {
    const onMove = (e) => {
      const x = e.clientX ?? e.touches?.[0]?.clientX;
      const y = e.clientY ?? e.touches?.[0]?.clientY;
      if (x === undefined) return;
      const dx = x - lastX, dy = y - lastY;
      if (dx * dx + dy * dy < 120) return;
      lastX = x; lastY = y;
      spawnTrail(x, y);
    };

    const onTap = (e) => {
      const x = e.clientX ?? e.changedTouches?.[0]?.clientX;
      const y = e.clientY ?? e.changedTouches?.[0]?.clientY;
      if (x === undefined) return;
      spawnBurst(x, y);
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    window.addEventListener("touchmove",  onMove, { passive: true });
    window.addEventListener("click",      onTap,  { passive: true });
    window.addEventListener("touchstart", onTap,  { passive: true });

    return () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("touchmove",  onMove);
      window.removeEventListener("click",      onTap);
      window.removeEventListener("touchstart", onTap);
    };
  }, []);

  return null;
}
